import { ThemeProvider } from "@mui/material";
import { participantTheme } from "../Components/ParticipantAuth/participantTheme";
import JoinCode from "../Components/ParticipantAuth/JoinCode";
import ParticipantLayout from "../Components/Layout/ParticipantLayout";
import ParHome from "../ParticipantHome";
import { AuthenticatedRoute } from "../utils/Route";
import ConsentFormsList from "../Components/ParticipantConsent/ConsentList";
import ConsentForm from "../Components/ParticipantConsent/Sign/ConsentForm/ConsentForm";
import SurveyPackage from "../Components/Survey/ParticipantSurvey/SurveyPackage";
import Survey from "../Components/Survey/ParticipantSurvey/Survey";
import ParticipantAppointments from "../Components/ParticipantAppointments/ParticipantAppointments";
// import SignIn from "../Components/ParticipantAuth/EmailPassAuth/SignIn";
// import SetPassword from "../Components/ParticipantAuth/EmailPassAuth/SetPassword";
// import ResetPassword from "../Components/ParticipantAuth/EmailPassAuth/ResetPassword";
// import PasswordResetSuccess from "../Components/ParticipantAuth/EmailPassAuth/PasswordResetSuccess";
// import ParticipantWelcome from "../Components/ParticipantAuth/EmailPassAuth/ParticipantWelcome";
// import ForgotPassword from "../Components/ParticipantAuth/EmailPassAuth/ForgotPassword";
// import CheckYourMail from "../Components/ParticipantAuth/EmailPassAuth/CheckYourMail";
// import OTPAuthentication from "../Components/ParticipantAuth/OTPAuth/OTPAuthentication";

// export const ParticipantSignIn = () => {
//   return (
//     <ThemeProvider theme={participantTheme}>
//       <SignIn />
//     </ThemeProvider>
//   );
// };

// export const ParticipantSetPassword = () => {
//   return (
//     <ThemeProvider theme={participantTheme}>
//       <SetPassword />
//     </ThemeProvider>
//   );
// };

// export const ParticipantResetPassword = () => {
//   return (
//     <ThemeProvider theme={participantTheme}>
//       <ResetPassword />
//     </ThemeProvider>
//   );
// };

// export const ParticipantPasswordResetSuccess = () => {
//   return (
//     <ThemeProvider theme={participantTheme}>
//       <PasswordResetSuccess />
//     </ThemeProvider>
//   );
// };

// export const ParticipantParticipantWelcome = () => {
//   return (
//     <ThemeProvider theme={participantTheme}>
//       <ParticipantWelcome />
//     </ThemeProvider>
//   );
// };

// export const ParticipantForgotPassword = () => {
//   return (
//     <ThemeProvider theme={participantTheme}>
//       <ForgotPassword />
//     </ThemeProvider>
//   );
// };

// export const ParticipantCheckYourMail = () => {
//   return (
//     <ThemeProvider theme={participantTheme}>
//       <CheckYourMail />
//     </ThemeProvider>
//   );
// };

// export const ParticipantOTPAuthentication = () => {
//   return (
//     <ThemeProvider theme={participantTheme}>
//       <OTPAuthentication />
//     </ThemeProvider>
//   );
// };

export const ParticipantJoinCode = () => {
  return (
    <ThemeProvider theme={participantTheme}>
      <JoinCode />
    </ThemeProvider>
  );
};

export const ParticipantLayoutComp = () => {
  return (
    <AuthenticatedRoute allowedRoles={["participant"]}>
      <ParticipantLayout />
    </AuthenticatedRoute>
  );
};

export const HomeComp = () => {
  return <ParHome />;
};

export const QuestionnaireComp = () => {
  return <SurveyPackage />;
};

export const SurveyComp = () => {
  return <Survey />;
};

export const EConsentComp = () => {
  return <ConsentFormsList />;
};

export const SignConsent = () => {
  return (
    <AuthenticatedRoute>
      <ThemeProvider theme={participantTheme}>
        <ConsentForm />
      </ThemeProvider>
    </AuthenticatedRoute>
  );
};

export const ParticipantAppointmentsComp = () => {
  return (
    <AuthenticatedRoute>
      <ThemeProvider theme={participantTheme}>
        <ParticipantAppointments />
      </ThemeProvider>
    </AuthenticatedRoute>
  );
};
